import React, { useContext } from 'react'
import { billing_period_options, PAYMENT_FEE } from '../../../Constants'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import { SessionContextStore } from '../../../context/SessionContext'
import { CentPretty } from '../../../services/utils'
import { HelpIcon } from './assets'
import { Collapse, Tooltip } from './components'
import { calcToalAmountBaseOnEstimatedMileage } from './utils'
import { StatesContextStore } from '../../../context/StatesContext'

export default ({ vehiclesDetailes, pricebreakdown, billingPeriod, billingFlowType, ...props }) => {
  const { user, newPaymentFlow } = useContext(SessionContextStore)
  const statesContext = React.useContext(StatesContextStore)
  const paymentFee = statesContext.no_initial_payment_fee.includes(user.administrativeDivision) ? 0 : PAYMENT_FEE

  return (
    <div
      style={{
        backgroundColor: 'var(--white)',
        overflow: 'hidden',
        padding: '0 .5rem',
        boxShadow: '0px -18px 15px 0px rgba(50, 50, 50, 0.18)',
      }}
    >
      <div
        style={{
          display: 'flex',
          height: '2rem',
          alignItems: 'center',
          fontSize: '16px',
          fontWeight: 'bold',
          fontFamily: 'Poppins-Bold',
        }}
      >
        <div className="flex">
          <div style={{ marginRight: '.3rem' }}>Total Due Today</div>
          {newPaymentFlow ? (
            <Tooltip
              text="The amount shown is based on the selected payment recurrence and includes an upfront payment for the initial miles
                        of that period. Pricing under $50 will involve an extra amount to reach the minimum issuance fee of $50. Any extra amount needed to reach this $50 will be applied as credit for upcoming months."
            >
              <HelpIcon color="black" />
            </Tooltip>
          ) : (
            <Tooltip text="The amount shown includes any required additional fees (see more on payment page). Pricing under $50 will involve an extra amount to reach the minimum issuance fee of $50. Any extra amount needed to reach this $50 will be applied as credit for upcoming months.">
              <HelpIcon color="black" />
            </Tooltip>
          )}
        </div>
        <div style={{ marginLeft: 'auto' }}>
          {calcToalAmountBaseOnEstimatedMileage(
            user.userVehicles,
            pricebreakdown,
            billingPeriod,
            billingFlowType,
            paymentFee
          ).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </div>
      </div>

      <Collapse
        {...(vehiclesDetailes.length <= 1 && { disabled: true })}
        open={`${vehiclesDetailes.length * 2.6}rem`}
        close="1.5rem"
        title={
          <div className="flex justify-between" style={{ fontSize: '14px' }}>
            <div>{billing_period_options[billingPeriod].label} offering:</div>
            <div>
              {pricebreakdown.billingPeriodOffering.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
              })}
              + {CentPretty(pricebreakdown.perMileCharge)} per mile
            </div>
          </div>
        }
      >
        {vehiclesDetailes.length > 1 &&
          vehiclesDetailes.map(vehicle => (
            <div key={vehicle.vehicleId} className="flex" style={{ fontSize: '14px' }}>
              <div className="truncate">
                {vehicle.make} | {vehicle.model} | {vehicle.year}
              </div>
              <div style={{ marginLeft: 'auto', fontFamily: 'Poppins-bold', flexShrink: '0', paddingLeft: '0.5rem' }}>
                {CentPretty(vehicle.perMilePrice)} per mile
              </div>
            </div>
          ))}
      </Collapse>
    </div>
  )
}
